"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationResponse = exports.PaginationQuery = void 0;
class PaginationQuery {
}
exports.PaginationQuery = PaginationQuery;
class PaginationResponse {
}
exports.PaginationResponse = PaginationResponse;
//# sourceMappingURL=entity-repository.js.map